export const create = {
  REQUIRE_RELIGION: ['CG', 'TCG', 'TL'],
  REQUIRE_MARITAL: ['KH'],
  dialog: false,
  idFrontImageFile: null,
  idBackImageFile: null,
  bankImageFile: null,
  maritalStatusImageFile: null,
  religionImageFile: null,
  employee: null,
  isValid: null,
  isValid2: null,
  showTabValid: false,
  noTaxNumber: false,
  noInsuranceNumber: false,
  loading: false,
  addFamilyDialog: false,


  itemCode: null,
  initForm: false,
  imgViewer: false,
  angle: 0,
  hireDate: null,

  originForm: {},
  form: {
    updatingFamily: 1,
    // ****employee attribute*****name
    employeeCode: '',
    employeeName: '',
    phoneNumber: '',
    email: '',
    emergencyNumber: '',
    emergencyPhone: '',
    gender: '',
    birthday: '',
    idFrontImageUrl: '',
    idBackImageUrl: '',
    bankImageUrl: '',
    maritalImageUrl: '',
    religionImageUrl: '',
    idNumber: '',
    idDate: '',
    idPlace: '',
    city1Name: '',
    district1Name: '',
    ward1Name: '',

    city1Code: '',
    district1Code: '',
    ward1Code: '',
    address1: '',

    newCityId: '',
    newWardId: '',
    newCityId2: '',
    newWardId2: '',

    // ****base attribute*****
    originCode: '',
    religionCode: '',
    ethnicityCode: '',
    city2Code: '',
    district2Code: '',
    ward2Code: '',
    address2: '',

    educationLevelCode: '',
    educationMajorCode: '',
    universityCode: '',
    graduateStatus: null,

    maritalStatus: '',
    bankCode: '',
    bankNumber: '',
    status: 0,
    basicInfoConfirmed: true,
    idFrontImage: null,
    idBackImage: null,
    bankImage: null,
    insuranceNumber: '',
    taxNumber: '',
    hasPharmaCert: 'KHONG',
    idFrontImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    idBackImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    bankImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    MaritalImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    religionImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    pharmaCertUrl: "",
    familyMembers: [],
    applicationUrl: null,
    cvUrl: null,
    residenceUrl: null,
    insuranceUrl: null,
    educationCert1Url: null,
    educationCert2Url: null,
    educationCert3Url: null,
    educationCert4Url: null,
    educationCert5Url: null,
  },

  defaultForm: {
    updatingFamily: 1,
    // ****employee attribute*****name
    employeeCode: '',
    employeeName: '',
    phoneNumber: '',
    email: '',
    emergencyNumber: '',
    gender: '',
    birthday: '',
    idFrontImageUrl: '',
    idBackImageUrl: '',
    bankImageUrl: '',
    maritalImageUrl: '',
    religionImageUrl: '',
    idNumber: '',
    idDate: '',
    idPlace: '',
    city1Name: '',
    district1Name: '',
    ward1Name: '',

    city1Code: '',
    district1Code: '',
    ward1Code: '',
    address1: '',

    newCityId: '',
    newWardId: '',
    newCityId2: '',
    newWardId2: '',


    // ****base attribute*****
    originCode: '',
    religionCode: '',
    ethnicityCode: '',
    city2Code: '',
    district2Code: '',
    ward2Code: '',
    address2: '',

    educationLevelCode: '',
    educationMajorCode: '',
    universityCode: '',
    graduateStatus: null,

    maritalStatus: '',
    bankCode: '',
    bankNumber: '',
    status: 0,
    basicInfoConfirmed: true,
    idFrontImage: null,
    idBackImage: null,
    bankImage: null,
    insuranceNumber: '',
    taxNumber: '',
    hasPharmaCert: 'KHONG',
    idFrontImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    idBackImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    bankImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    MaritalImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    religionImageBase64: {
      base64: '',
      fileName: '',
      type: ''
    },
    pharmaCertUrl: "",
    familyMembers: [],
    applicationUrl: null,
    cvUrl: null,
    residenceUrl: null,
    insuranceUrl: null,
    educationCert1Url: null,
    educationCert2Url: null,
    educationCert3Url: null,
    educationCert4Url: null,
    educationCert5Url: null,
  },
  origins: [],
  religions: [],
  ethnicities: [],
  cities: [],
  cities2: [],
  altCities: [],
  altWards: [],
  altWards2: [],
  districts: [],
  districts2: [],
  wards: [],
  wards2: [],
  banks: [],
  educationLevels: [],
  universities: [],
  educationMajors: [],
  marriages: [
    { text: "Kết hôn", value: "KH" },
    { text: "Độc thân", value: "DT" },
    { text: "Chưa có thông tin", value: "" },
  ],

  family: {
    relationType: null,
    memberName: '',
    phoneNumber: '',
    doB: '',
    idNumber: '',
  },

  familyDefault: {
    relationType: null,
    memberName: '',
    memberEmployeeCode: null,
    // phoneNumber: '',
    // doB: '',
    // idNumber: '',
  },
  headers: [
    { text: '', value: 'actions' },
    { text: 'Mối quan hệ', value: 'relationType' },
    { text: 'Họ & tên', value: 'memberName' },
    { text: 'SDT', value: 'phoneNumber' },
    { text: 'Ngày sinh', value: 'doB' },
    { text: 'CCCD', value: 'idNumber' }
  ],
  familyMemberHeaders: [
    { text: '', value: 'actions' },
    { text: 'Mối quan hệ', value: 'relationType' },
    { text: 'Tên', value: 'memberName' },
    { text: 'Mã NS trong TS', value: 'memberEmployeeCode' },
    // {text: 'CCCD', value: 'idNumber'},
    // {text: 'SDT', value: 'phoneNumber'},
  ],
  tab: null,
  imgSrc: ""
}